import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const testimonials = [
  {
    text: 'Kakobuy Spreadsheet to najlepsze narzędzie jakie znalazłem do przeglądania produktów. Dzięki niemu zaoszczędziłem mnóstwo czasu na szukaniu sprawdzonych sprzedawców. Gorąco polecam każdemu kto dopiero zaczyna z Kakobuy!',
    name: 'Marek Kowalski',
    role: 'Użytkownik Kakobuy od 2024',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20stylish%20European%20man%20in%20his%20late%20twenties%20wearing%20cream%20knit%20sweater%2C%20clean%20warm%20beige%20studio%20backdrop%2C%20soft%20natural%20lighting%20from%20large%20window%2C%20friendly%20confident%20expression%2C%20editorial%20portrait%20photography%20with%20shallow%20depth%20of%20field&width=800&height=1000&seq=testimonial-v2-01&orientation=portrait',
  },
  {
    text: 'Dzięki arkuszom znalazłem produkty, których szukałem od miesięcy. Regularne aktualizacje i sprawdzeni sprzedawcy to coś, co wyróżnia ten serwis na tle innych. Świetna robota!',
    name: 'Anna Nowak',
    role: 'Użytkowniczka od 2025',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20a%20young%20European%20woman%20in%20her%20mid%20twenties%20with%20warm%20smile%20wearing%20olive%20green%20blouse%2C%20clean%20cream%20studio%20background%2C%20soft%20diffused%20natural%20light%2C%20editorial%20portrait%20photography%2C%20friendly%20approachable%20aesthetic&width=800&height=1000&seq=testimonial-v2-02&orientation=portrait',
  },
  {
    text: 'Jako początkujący użytkownik Kakobuy byłem zagubiony. Ten przewodnik i arkusze produktowe dosłownie uratowały mi życie. Wszystko jasno wytłumaczone, linki sprawdzone. Polecam w 100%!',
    name: 'Piotr Wiśniewski',
    role: 'Nowy użytkownik Kakobuy',
    imageUrl: 'https://readdy.ai/api/search-image?query=Candid%20portrait%20of%20a%20stylish%20European%20man%20in%20his%20early%20thirties%20with%20genuine%20expression%20wearing%20grey%20cashmere%20sweater%2C%20warm%20textured%20background%2C%20soft%20natural%20window%20lighting%2C%20editorial%20portrait%20photography%20with%20relaxed%20natural%20pose&width=800&height=1000&seq=testimonial-v2-03&orientation=portrait',
  },
];

export default function TestimonialSection() {
  const { t } = useTranslation('home');
  const [activeIndex, setActiveIndex] = useState(0);

  const goNext = () => setActiveIndex((prev) => (prev + 1) % testimonials.length);
  const goPrev = () => setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const current = testimonials[activeIndex];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-center">
          <div className="w-full lg:w-[38%] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                src={current.imageUrl}
                alt={current.name}
                title={`Opinia ${current.name} - Kakobuy Spreadsheet`}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="flex-1">
            <span className="inline-block text-foreground-400 text-xs font-label uppercase tracking-wider mb-6">
              ({t('testimonial_tag')})
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3 leading-tight">
              {t('testimonial_title_1')}
            </h2>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-300 mb-10 leading-tight">
              {t('testimonial_title_2')}
            </h2>

            <blockquote className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8 font-body italic border-l-2 border-primary-500 pl-6">
              &ldquo;{current.text}&rdquo;
            </blockquote>

            <div className="flex items-center justify-between">
              <div>
                <p className="text-foreground-950 font-label font-semibold text-sm">&mdash; {current.name}</p>
                <p className="text-foreground-400 text-xs font-body mt-0.5">{current.role}</p>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={goPrev}
                  className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:text-foreground-950 hover:border-foreground-500 transition-colors duration-200 cursor-pointer"
                  aria-label="Poprzednia opinia"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={goNext}
                  className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-colors duration-200 cursor-pointer"
                  aria-label="Następna opinia"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="flex gap-2 mt-6">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIndex(idx)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    idx === activeIndex ? 'bg-primary-500 w-6' : 'bg-foreground-200'
                  }`}
                  aria-label={`Opinia ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}